// Builds a BreadcrumbList JSON-LD object from an ordered list of
// { name, url } crumbs (Home first, current page last).
export function useBreadcrumbSchema(items, pageUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${pageUrl}#breadcrumb`,
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
